import React, { useState, useReducer } from "react";
import { Upload, Avatar, Row, Col, Card, Button, Form, Badge, message } from "antd";
import { CheckOutlined, DeleteFilled } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { BACKEND_URL } from "../../../../services/backendURL";
import { initialState, reducer } from "./reducer";
import Edit from "./components/Edit";
import View from "./components/View";
import { setMemberPhoto } from "../../../../store/actions";
import ProfileService from "../../../../services/Profile/ProfileService";



const MemberProfileDetail = () => {
    const dispatchRedux = useDispatch();
    const token = useSelector((state) => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const memberData = useSelector((state) => state.Member.member_data);
    const initialPhotoUrl = BACKEND_URL + memberData.photo;
    const [form] = Form.useForm();
    const [avatarUrl, setAvatarUrl] = useState(initialPhotoUrl);
    const [avatarChanged, setAvatarChanged] = useState(false);
    const [fileSelected, setFileSelected] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const beforeUploadHandler = () => {
        return false;
    };

    const onUploadAvatar = (info) => {
        setDisabled(false);
        setFileSelected(info.file.originFileObj);
        getBase64(info.file.originFileObj, (imageUrl) => {
            setAvatarUrl(imageUrl);
            setAvatarChanged(true);
        });
    };

    const formatRequestData = (formData) => {
        let requestData = new FormData();
        requestData.append('photo', fileSelected);
        return requestData;
    }


    const onUpdate = () => {
        setLoading(true);
        form
            .validateFields()
            .then((data) => {
                const requestData = formatRequestData(data);
                ProfileService.updateProfilePhoto(token, requestData)
                    .then((response) => {
                        const photoUrl = BACKEND_URL + response.data.photo;
                        dispatchRedux(setMemberPhoto(response.data.photo));
                        setAvatarUrl(photoUrl);
                        message.success("Foto u ndryshua me sukses!", 1).then(() => {
                            setDisabled(true);
                            setLoading(false);
                        });
                    })
                    .catch((err) => {
                        message.error("Një gabim ndodhi gjatë ndryshimit të fotos!", 2).then(() => { setLoading(false); });
                    });
            })
            .catch((info) => {
                setLoading(false);
            });
    };


    const onRemoveAvatar = () => {

        if (avatarUrl.toString().includes('data:image') || avatarUrl === BACKEND_URL) {
            setAvatarUrl(initialPhotoUrl);
            setAvatarChanged(true);
            setDisabled(true);
            return;
        }


        ProfileService.deleteProfilePhoto(token)
            .then((response) => {
                const photoUrl = BACKEND_URL + response.data.photo;
                dispatchRedux(setMemberPhoto(response.data.photo));
                setAvatarUrl(photoUrl);
                message.success("Foto u fshi me sukses!", 1).then(() => {
                    setDisabled(true);
                    setLoading(false);
                });
            })
            .catch((err) => {
                message.error("Një gabim ndodhi gjatë fshirjes së fotos!", 2).then(() => { setLoading(false); });
            });
    };


    const updateIndexVisibility = (indexVisibility) => {
        const action = {
            type: "set_index_visibility",
            payload: indexVisibility,
        };
        dispatch(action);
    };


    const onSuccess = () => {
        updateIndexVisibility(0);
    };


    return (
        <>
            <Card style={{ backgroundColor: "#a461d836" }} className='text-center' bodyStyle={{ padding: '15px' }}>
                <h3 className="m-0 p-0" style={{ color: "#751fad" }}>{memberData?.name + " " + memberData?.surname}</h3>
            </Card>
            <Card style={{ minHeight: '357px' }}>
                <Row gutter={24}>
                    <Col xl={7} lg={7} md={24} sm={24} xs={24}>
                        <Form
                            form={form}
                            layout="vertical"
                        >
                            <Row gutter={24} align="middle">
                                <Col span={24} className="text-center">
                                    <Upload
                                        beforeUploadHandler={beforeUploadHandler}
                                        onChange={onUploadAvatar}
                                        showUploadList={false}
                                    >
                                        <Badge count="+ Foto" style={{ color: '#fff', backgroundColor: '#a461d8', fontSize: '14px' }}>
                                            <Avatar
                                                size={120}
                                                style={{ color: "#a461d8", backgroundColor: "#fcf0ff", fontSize: "40px", border: "1px solid #a461d8" }}
                                                src={avatarUrl}
                                            >
                                                <p>{memberData?.name.toString().charAt(0) + memberData?.surname.toString().charAt(0)}</p>
                                            </Avatar>
                                        </Badge>
                                    </Upload>
                                </Col>
                                <Col span={24} className="text-center mt-4">
                                    <Button
                                        type="primary"
                                        onClick={onUpdate}
                                        icon={<CheckOutlined />}
                                        loading={loading}
                                        disabled={!avatarChanged || disabled}>
                                        Ruaj
                                    </Button>
                                    <Button danger className="ml-3" onClick={onRemoveAvatar} icon={<DeleteFilled />} disabled={(!avatarChanged && avatarUrl === "") || avatarUrl === BACKEND_URL || avatarUrl === null}>
                                        Fshi
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col xl={1} lg={1} md={24} sm={24} xs={24}></Col>
                    <Col xl={16} lg={16} md={24} sm={24} xs={24}>

                        {state.indexVisibility === 0 && (
                            <View
                                memberData={memberData}
                                onEdit={() => updateIndexVisibility(1)}
                            />
                        )}

                        {state.indexVisibility === 1 && (
                            <Edit
                                dispatch={dispatch}
                                memberData={memberData}
                                onSuccess={onSuccess}
                                onClose={() => updateIndexVisibility(0)}
                            />
                        )}

                    </Col>
                </Row>
            </Card>
        </>
    );
};

export default MemberProfileDetail;